import type { MoodEntry } from '../../types/mood';

export const uplifted: MoodEntry = {
  id: 'uplifted',
  name: 'Uplifted',
    synonyms: ['bright', 'buoyant', 'energised', 'lighthearted', 'hopeful', 'serendipitous', 'luminous'],
    related: ['optimistic', 'joyful', 'encouraged', 'motivated'],
    antonyms: [
  'low',
  'depressed',
  'sad',
  'flat',
  'heavy',
  'dull',
  'drained',
  'hopeless',
  'discouraged',
  'down',
  'blue',
  'empty',
  'unmotivated',
  'heavy',
  'unfortunate',
  'unlucky',
  'dim',
  'dull',
],
    behaviours: ['quicker steps', 'open gestures', 'warm tone', 'increased curiosity'],
    actions: ['send a kind message', 'play a favourite song', 'refresh your space', 'share a small win'],
    phrases: ['Let the light in.', 'Carry the good forward.', 'Small joys matter.', 'Energy rises when shared.'],
    quotes: [
      '“Where there is light, there is joy.” — Anne Frank',
      '“Happiness is not something ready-made. It comes from your own actions.” — Dalai Lama'
    ],
    palette: ['#FFE8A3', '#FFD97A', '#FFCC66', '#F9B94E'],
    season: 'Spring'
  };